import {useRails} from '~/react/contexts/rails'
import usePolling from '~/react/hooks/usePolling'
import {mutate} from 'swr'

export const useDashboardData = () => {
  const {currentSupplier} = useRails()
  const supplierId = currentSupplier?.id
  const url = supplierId
    ? `/points/api/suppliers/${supplierId}/dashboard_data`
    : null

  const result = usePolling(url, true, 10000)

  const refresh = () => {
    if (url) {
      mutate(url)
    }
  }

  return {...result, refresh}
}
